/**
 * Shared form field tailwind class constants.
 *
 * These are plain className strings (not components) so they can be applied to any element —
 * e.g. a `<label>` in `FormField`, or a `<legend>` in `FormFieldset` — keeping field labels and
 * messages visually identical regardless of the underlying semantic element.
 */
export const formLabelClassName = 'type-label text-text-primary';
export const formDescriptionClassName = 'type-caption text-text-muted';
export const formErrorMessageClassName = 'type-caption text-danger-500';
export const formSuccessMessageClassName = 'type-caption text-success-600';
export const formRequiredMarkClassName = 'ml-0.5 text-danger-500';
